import React from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { CustomButton } from '../../../../../layout/styledcomponents/CustomButton';

type Props = {
    open: boolean;
    isDeleting: boolean;
    onClose: () => void;
    onKeepItem: () => void;
    onRemoveItem: () => void;
};

export default function ItineraryItemDeleteModal({
    open,
    isDeleting,
    onClose,
    onKeepItem,
    onRemoveItem,
}: Props) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth='xs'>
            <DialogTitle>
                Remove Itinerary Item ?
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Typography sx={{ fontSize: 14 }}>
                        Are you sure you want to remove this itinerary item?
                        This action cannot be undone.
                    </Typography>
                </DialogContentText>
            </DialogContent>
            <DialogActions
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <CustomButton
                    variant='outlined'
                    color='primary'
                    onClick={onKeepItem}
                    disabled={isDeleting}
                >
                    Keep item
                </CustomButton>

                <CustomButton
                    variant='contained'
                    onClick={onRemoveItem}
                    color='warning'
                >
                    Remove item
                </CustomButton>
            </DialogActions>
        </Dialog>
    );
}
